import { CutOffTimeList } from './CutOffTimeList';

export default CutOffTimeList;